import en from './en.translations.json.js';
import de from './de.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import es from './es.translations.json.js';
import nl from './nl.translations.json.js';

const uiCursorPaginationTranslationsDe = { ...de };
const uiCursorPaginationTranslationsEn = { ...en };
const uiCursorPaginationTranslationsEs = { ...es };
const uiCursorPaginationTranslationsFr = { ...fr };
const uiCursorPaginationTranslationsIt = { ...it };
const uiCursorPaginationTranslationsNl = { ...nl };
const uiCursorPaginationTranslationsBundle = {
  de: uiCursorPaginationTranslationsDe,
  en: uiCursorPaginationTranslationsEn,
  es: uiCursorPaginationTranslationsEs,
  fr: uiCursorPaginationTranslationsFr,
  it: uiCursorPaginationTranslationsIt,
  nl: uiCursorPaginationTranslationsNl
};

export { uiCursorPaginationTranslationsBundle, uiCursorPaginationTranslationsDe, uiCursorPaginationTranslationsEn, uiCursorPaginationTranslationsEs, uiCursorPaginationTranslationsFr, uiCursorPaginationTranslationsIt, uiCursorPaginationTranslationsNl };
